// extracted by css-extract-rspack-plugin
export default {"success":"success-kI0N7_","error":"error-vmOCU0","info":"info-MBHOfP","warning":"warning-a3izdK","icon":"icon-gcDtKD","iconVariant":"iconVariant-z3Qxf7","message":"message-xnr3HY"};